import locale from "@/utils/locale";
import type { NoticeItemRaw } from "../types";

const formatLocaleNumber = (value: unknown): string => {
  if (value == null || value === "") return "";
  const num = Number(value);
  if (isNaN(num)) return String(value);
  return num.toLocaleString();
};

const isNumeric = (value: unknown): boolean => !isNaN(+String(value));

type NoticeWithExtras = NoticeItemRaw & {
  amount?: unknown;
  extra?: Record<string, unknown>;
};

/** 站内信标题（i18n key 或原文） */
export function getNoticeTitle(
  notice: NoticeItemRaw,
  t: (key: string) => string
): string {
  return t(notice.title);
}

/** 站内信正文：优先 content，与详情页一致 */
export function formatNoticeDescription(
  notice: NoticeItemRaw,
  currencySymbol: string
): string {
  const item = notice as NoticeWithExtras;
  const rawText = notice.content?.trim() || notice.description || "";
  const params = {
    amount: formatLocaleNumber(item.amount),
    symbol: currencySymbol,
    ...Object.entries(item.extra || {}).reduce(
      (acc, [key, value]) => {
        acc[key] = isNumeric(value) ? formatLocaleNumber(value) : value;
        return acc;
      },
      {} as Record<string, unknown>
    ),
  };
  return locale.get(rawText, params);
}
